import {Condition, type Journey} from "../engine/Condition";

export interface StayOnPageOptions {
    seconds: number;
}

export class StayOnPageCondition extends Condition<StayOnPageOptions> {
    stayedOnPage = false;

    constructor(journey: Journey, options: StayOnPageOptions, requestReEval: () => void) {
        super(journey, options, requestReEval);
        this.attachTimeout(() => {
            this.stayedOnPage = true;
            this.requestReEval();
        }, this.options.seconds * 1000);
    }

    evaluate() {
        return this.stayedOnPage;
    }
}
